/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'checkout': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(8 8)" _stroke="#00272E"><path pid="0" d="M9 3.333V1a.667.667 0 00-.667-.667H1A.667.667 0 00.333 1v14c0 .368.299.667.667.667h7.333A.667.667 0 009 15v-2.333"/><path pid="1" d="M15.667 8H3"/><polyline pid="2" points="12.3333333 11.3333333 15.6666667 8 12.3333333 4.66666667"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/checkout.js